import { useTokenPrice, UseTokenPriceResult } from './useTokenPrice';

export type UsePolPriceResult = UseTokenPriceResult;

export const usePolPrice = (): UsePolPriceResult => useTokenPrice('polPriceUpdate');
